import { HttpInterceptorFn } from '@angular/common/http';

export const xsrfInterceptor: HttpInterceptorFn = (req, next) => {
    const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
    if (match) {
        return next(
            req.clone({
                withCredentials: true,
                setHeaders: { 'X-XSRF-TOKEN': decodeURIComponent(match[1]) }
            })
        );
    }

    return next(req);
};
